module.exports = __webpack_public_path__ + "static/media/scotia-vida-img-028.cb735bda.svg";